<template>
  <div class="" :class="iframeUrl != '' ? 'page-fixed' : ''">
    <h5 class="detail-title">{{ infoData.title }}</h5>
    <div class="detail-subtitle">
      <span class="first-tab" v-if="infoData.source">{{
        infoData.source
      }}</span>
      <span class="sec-tab" v-if="infoData.pubTime">{{
        infoData.pubTime | timeStampToString
      }}</span>
    </div>
    <iframe ref="iframe" id="iframe" :src="iframeUrl" v-if="iframeUrl != ''">
    </iframe>
    <!-- <div
      class="richText"
      v-else
      v-html="richText"
      @click="addComment($event)"
    ></div> -->
    <quil-editor :richText="richText"></quil-editor>
    <van-empty
      v-if="noData"
      :image="require('../../../assets/img-m/no-list.png')"
      :description="$t('暂无数据')"
    />
    <!-- <van-image-preview v-model="show" :images="images"></van-image-preview> -->
  </div>
</template>

<script>
import getTranslation from '@/locale/getTranslation'
import { getDescribeContentApi } from '@/api/exhibition'
import QuilEditor from '@/components/QuilEditor'
export default {
  data() {
    return {
      infoData: {},
      iframeUrl: '',
      richText: '',
      noData: false
    }
  },
  components: {
    QuilEditor
  },
  beforeCreate() {
    let share = this.$route.query.share || ''
    if (share !== 'no') {
      try {
        let options = {
          source: '活动资讯',
          isShow: true
        }
        window.bridge.onShowShareButton(JSON.stringify(options))
      } catch (error) {
        console.log('APP调起分享按钮监听失败')
      }
    }
    this.$toast.loading({
      duration: 0,
      message: getTranslation('加载中...'),
      forbidClick: true
    })
  },
  beforeMount() {
    let id = this.$route.query.id
    this.getDetailView(id)
  },
  methods: {
    getDetailView(id) {
      getDescribeContentApi({
        id
      }).then(res => {
        let content = res.result.content
        this.infoData = content
        let { contentType, richText, url, title } = content
        document.title = title
        //richText富文本内容
        if (contentType == 2) {
          if (richText !== '') this.richText = richText
          else this.noData = true
        } else {
          this.iframeUrl = url
        }
        this.$toast.clear()
      })
    },
    addComment: function(event) {
      switch (event.target.nodeName) {
        case 'A': {
          event.preventDefault()
          const url = event.target.href
          const fileType = url.substring(url.lastIndexOf('.') + 1)
          try {
            let options = {
              source: '活动资讯',
              fileType,
              url
            }
            window.bridge.onFileDownload(JSON.stringify(options))
          } catch (error) {
            console.log('调用APP下载方法失败')
            window.open(event.target.href)
          }
          break
        }
        case 'IMG': {
          if (event.target.parentNode.tagName !== 'A') {
            event.preventDefault()
            this.images = [event.target.currentSrc]
            this.show = true
          }
          break
        }
      }
    }
  }
}
</script>
<style lang="css">
.detail-title {
  font-size: 0.45rem;
  padding: 0.3rem;
  line-height: 130%;
}
.detail-subtitle {
  font-size: 0.24rem;
  line-height: 100%;
  padding: 0 0.3rem;
}
.first-tab {
  margin-right: 0.2rem;
  color: #fe8c01;
}
.sec-tab {
  color: #bcbcbc;
  font-size: 0.24rem;
}
</style>
